import { toast } from '@/ui/primitives/aviso';
import { type ConsultaChaveResposta, type ExecucaoCaptura } from '@fiscoai/contracts';

import {
  resumoExecucao,
  rotaDocumento,
  temNota,
  TITULO_RESULTADO_CHAVE,
  TOM_RESULTADO_CHAVE,
} from './textos';

const POR_TOM = {
  sucesso: toast.success,
  info: toast.info,
  alerta: toast.warning,
  perigo: toast.error,
} as const;

/** Toast do fim do "Buscar agora" com o que veio ("3 notas novas e 1 evento"). */
export function avisarBusca(execucao: ExecucaoCaptura | null): void {
  if (!execucao) {
    toast.info('A busca continua na SEFAZ', {
      description: 'Ela demorou mais que o normal. O resultado aparece no histórico.',
    });
    return;
  }
  const descricao = resumoExecucao(execucao);
  if (execucao.status === 'CONCLUIDA') toast.success('Busca concluída', { description: descricao });
  else if (execucao.status === 'SEM_NOVIDADE')
    toast.info('Busca concluída', { description: descricao });
  else if (execucao.status === 'ERRO') toast.error('A busca falhou', { description: descricao });
  else toast.warning('A SEFAZ não atendeu a busca', { description: descricao });
}

/** Toast do resultado da consulta por chave, com "Abrir nota" quando ela já está no FiscoAI. */
export function avisarConsultaChave(r: ConsultaChaveResposta, abrir: (rota: string) => void): void {
  POR_TOM[TOM_RESULTADO_CHAVE[r.resultado]](TITULO_RESULTADO_CHAVE[r.resultado], {
    description: r.mensagem,
    ...(temNota(r)
      ? {
          action: {
            label: 'Abrir nota',
            onClick: () => {
              abrir(rotaDocumento(r.documentoId));
            },
          },
        }
      : {}),
  });
}
